(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/xapi', {
      templateUrl: 'modules/app/data/xapi/xapi.html',
      controller: 'XapiCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('XapiCtrl', ['$scope', '$http', 'Api', 'Logger', 'Utils', 'User', 'UserRoles', function ($scope, $http, Api, Logger, Utils, User, UserRoles) {
    var user = User.get();
    $scope.isAdmin = UserRoles.isOrgAdmin(user);
    $scope.section = "xapi";
    $scope.lrsAccessLevels = ['disabled', 'isolated', 'global', 'global_read_only', 'write_only'];
    $scope.wsApiAccessLevels = ['disabled', 'enabled'];
    $scope.createNewAccount = function createNewAccount() {
      $http.post(Api.url("/activity-providers"), {
        "name": "Unnamed Provider"
      }).then(function createAccountSuccess() {
        $scope.setAccountsPage(0);
      }, function createAccountError(response) {
        Logger.error("Create system account failed with response status " + response.status);
        $scope.error = "There was an error creating the system account.";
      });
    };
    $scope.fetchAccountsPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      return $http.get(Api.url("/activity-providers"), {
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": "-id"
        }
      }).then(function fetchAccountsSuccess(r) {
        $scope.accountsPage = r.data.results;

        // Filter out special "hidden" bookmarklet activity provider account.  If we end up with
        // any other special accounts like this we'll want to add a 'hidden' flag to the actual
        // activity provider data model.
        $scope.accountsPage = _.filter($scope.accountsPage, function (a) {
          return a.name !== "ws_bookmarklet";
        });
        return r.data;
      }, function fetchAccountsError(response) {
        Logger.error("Account fetch failed with response status " + response.status);
        $scope.error = "There was an error fetching the system accounts.";
      });
    };
    $scope.pagerLoaded = function () {
      $scope.setAccountsPage(0);
    };
    $scope.$on("system-account-delete", function accountDelete(evt, index) {
      $scope.accountsPage = Utils.removeAt($scope.accountsPage, index);
    });
    $scope.$on("system-account-edited", function accountEdited(evt, account, index) {
      $scope.accountsPage[index] = account;
    });
    $scope.lrsEndpoint = Utils.qualifyURL(Api.url("/lrs/"));
  }]).controller('ActivityProviderItemCtrl', ['$scope', '$http', 'Api', 'Logger', 'Utils', 'Validation', function ($scope, $http, Api, Logger, Utils, Validation) {
    function validateForm(scope) {
      return Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": scope.editCopy.name
        },
        "key": {
          "rules": {
            "required": true,
            "minLength": 14
          },
          "value": scope.editCopy.key
        },
        "secret": {
          "rules": {
            "required": true,
            "minLength": 14
          },
          "value": scope.editCopy.secret
        }
      });
    }
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.account);
      $scope.saving = false;
      $scope.editing = false;
      $scope.formErrors = null;
      $scope.saveError = null;
    }
    $scope.startEditing = function startEditing() {
      resetEditingState();
      $scope.editing = true;
    };
    $scope.save = function save() {
      $scope.formErrors = validateForm($scope);
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $scope.saveError = null;
      $http.put(Api.url("/activity-providers/" + $scope.account.id), $scope.editCopy).then(function accountUpdateSuccess() {
        $scope.account = $scope.editCopy;
        $scope.saving = false;
        $scope.editing = false;
        $scope.formErrors = null;
        $scope.saveError = null;
        $scope.$emit("system-account-edited", $scope.account, $scope.$index);
        delete $scope.editCopy;
        delete $scope.account;
      }, function accountUpdateFail(response) {
        Logger.error("Update system account failed with response status " + response.status);
        $scope.saveError = "There was an error updating the account.";
        $scope.saving = false;
      });
    };
    $scope.cancel = function cancel() {
      resetEditingState();
    };
    $scope.remove = function remove() {
      $scope.deleteError = null;
      $http['delete'](Api.url("/activity-providers/" + $scope.account.id)).then(function deleteAccountSuccess() {
        $scope.$emit("system-account-delete", $scope.$index);
        $scope.setAccountsPage(0);
      }, function deleteAccountFail(response) {
        Logger.error("An error occurred deleting system account with id " + $scope.account.id + "." + "Failed with status " + response.status);
        $scope.deleteError = "There was error in deleting the account.";
      });
    };
    $scope.regenSecret = function regenSecret() {
      $scope.editCopy.secret = Utils.randomId($scope.editCopy.secret.length);
    };
  }]).controller('InboundDataSourcesCtrl', ['$scope', '$http', 'Api', 'Logger', 'Utils', 'User', function ($scope, $http, Api, Logger, Utils, User) {
    $http.get(Api.url("/statement-pipes")).then(function fetchStatementPipesSuccess(response) {
      $scope.inboundDataSources = response.data.results.filter(function (pipe) {
        return pipe.pipeType === "pull";
      });
    }, function fetchStatementPipesError(response) {
      Logger.error("Statement Pipes fetch failed with response status " + response.status);
      $scope.error = "There was an error fetching the statement pipes.";
    });
    $scope.editorConfig = {
      "canConfigUseNameAsAuthority": false,
      //set to true to reveal 'Use Name as Authority' checkbox
      "useNameAsAuthority": true
    };
    $scope.shouldUseNameAsAuthority = function shouldUseNameAsAuthority() {
      return $scope.editorConfig.useNameAsAuthority;
    };

    // does dataSource statement-pipe have a linked activity-provider?
    $scope.usesNameAsAuthority = function usesNameAsAuthority(dataSource) {
      return dataSource !== null && dataSource !== undefined && dataSource.activityProviderId !== null && dataSource.activityProviderId !== undefined;
    };
    $scope.createNewInboundDataSource = function createNewInboundDataSource() {
      var newInboundDataSource = {
        "organization": {
          "id": User.get().organization.id
        },
        "name": "",
        "id": null,
        "pipeType": "pull",
        "targetUrl": Utils.qualifyURL(Api.url("/lrs/")),
        "targetUsername": "INSERTED-SERVER-SIDE",
        "targetPW": "INSERTED-SERVER-SIDE",
        "sourceUrl": "",
        "sourceUsername": "",
        "sourcePW": "",
        "statementCount": 0
      };
      newInboundDataSource.isNew = true;
      if ($scope.shouldUseNameAsAuthority()) {
        newInboundDataSource.activityProviderId = -1;
      }
      $scope.inboundDataSources.push(newInboundDataSource);
    };
    $scope.$on("inbound-statementpipe-delete", function inboundStmtPipeDelete(evt, index) {
      $scope.inboundDataSources = Utils.removeAt($scope.inboundDataSources, index);
    });
  }]).controller('InboundDataSourceItemCtrl', ['$scope', '$http', '$uibModal', 'Api', 'Logger', 'Utils', 'Validation', function ($scope, $http, $uibModal, Api, Logger, Utils, Validation) {
    function validateForm(scope) {
      return Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": scope.editCopy.name
        },
        "sourceUrl": {
          "display": "Endpoint URL",
          "rules": {
            "required": true,
            "url": true
          },
          "value": scope.editCopy.sourceUrl
        },
        "sourceUsername": {
          "display": "Key",
          "rules": {
            "required": true
          },
          "value": scope.editCopy.sourceUsername
        },
        "sourcePW": {
          "display": "Secret",
          "rules": {
            "required": false
          },
          "value": scope.editCopy.sourcePW
        },
        "lastStoredTimestamp": {
          "display": "Last Timestamp",
          "rules": {
            "required": false,
            "timestamp": true
          },
          "value": scope.editCopy.lastStoredTimestamp
        }
      });
    }
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.ds); // ds variable is from the ng-repeat iterator
      $scope.saving = false;
      $scope.editing = false;
      $scope.editingSecret = false;
      $scope.formErrors = null;
      $scope.saveError = null;
    }
    resetEditingState();

    // Newly added rows will have a "new" property which we use to immediately show the editing view
    if ($scope.ds.isNew === true) {
      $scope.editing = $scope.editingSecret = true;
      delete $scope.ds.isNew;
    }
    $scope.save = function save() {
      $scope.formErrors = validateForm($scope);
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $scope.saveError = null;
      if ($scope.editCopy.id === null) {
        $http.post(Api.url("/statement-pipes"), $scope.editCopy).then(function createDataSourceSuccess(response) {
          $scope.ds = $scope.editCopy;
          $scope.ds.id = Utils.getIdFromCreatedResponse(response);
          $scope.ds.isNew = null;
          if ($scope.usesNameAsAuthority(response.data)) {
            $scope.ds.activityProviderId = response.data.activityProviderId;
          }
          resetEditingState();
        }, function createDataSourceError(response) {
          Logger.error("Create statement pipe failed with response status " + response.status);
          $scope.saveError = response.data.message;
          $scope.saving = false;
        });
      } else {
        $http.put(Api.url("/statement-pipes/" + $scope.ds.id), $scope.editCopy).then(function statementPipeUpdateSuccess() {
          $scope.ds = $scope.editCopy;
          resetEditingState();
        }, function statementPipeUpdateFail(response) {
          Logger.error("Update statement pipe failed with response status " + response.status);
          $scope.saveError = response.data.message;
          $scope.saving = false;
        });
      }
    };
    $scope.cancel = function cancel() {
      // If it was a new (never saved) pipe and you cancel, remove the row from the UI
      if ($scope.ds.id === null) {
        $scope.$emit("inbound-statementpipe-delete", $scope.$index);
      }
      resetEditingState();
    };
    $scope.remove = function remove() {
      $scope.deleteError = null;
      $http['delete'](Api.url("/statement-pipes/" + $scope.ds.id)).then(function deleteStatementPipeSuccess() {
        $scope.$emit("inbound-statementpipe-delete", $scope.$index);
      }, function deleteStatementPipeError(response) {
        Logger.error("An error occurred deleting statement pipe with id " + $scope.ds.id + "." + "Failed with status " + response.status);
        $scope.deleteError = "There was error in deleting the statement pipe.";
      });
    };
    $scope.showErrors = function showErrors() {
      $uibModal.open({
        controller: "StatementPipeErrorModalCtrl",
        templateUrl: 'modules/app/data/xapi/statement-pipe-error-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          statementPipe: function statementPipe() {
            return $scope.ds;
          }
        }
      });
    };
  }]).controller('StatementPipeErrorModalCtrl', ['$scope', '$http', '$timeout', '$uibModalInstance', 'Api', 'Logger', 'Utils', 'statementPipe', function ($scope, $http, $timeout, $uibModalInstance, Api, Logger, Utils, statementPipe) {
    $scope.inbound = statementPipe.pipeType === 'pull';
    $scope.pipeError = statementPipe.errorMessage;
    $scope.errors = [];
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
    $scope.fetchErrorPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      return $http.get(Api.url("/statement-pipes/" + statementPipe.id + "/error-statements"), {
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": "-id"
        }
      }).then(function success(r) {
        return r.data;
      }, function fetchAccountsError(response) {
        Logger.error("Error fetch failed with response status " + response.status);
        $scope.error = "There was an error fetching the errors.";
      });
    };
    $timeout(function () {
      $scope.setErrorPage(0);
    }, 0);
    $scope.clearErrors = function clearErrors() {
      $scope.deleteError = null;
      $http['delete'](Api.url("/statement-pipes/" + statementPipe.id + "/error-statements", true)).then(function deleteStatementPipeSuccess() {
        statementPipe.errorStatementCount = 0;
        delete statementPipe.errorStatements;
      }, function deleteStatementPipeError(response) {
        Logger.error("An error occurred deleting statement pipe errors with id " + statementPipe.id + "." + "Failed with status " + response.status);
        $scope.deleteError = "There was error in deleting errors for the statement pipe.";
      });
    };
  }]);
})();
